var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "is-showing-bandana": false,
        "is-showing-sitewide-modal": false,
        "is-showing-v7-prerelease-notice": true,
      },
    },
    [
      _c("wa-page-header", {
        key: "header",
        attrs: { slot: "header" },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _c("plans-header-section", {
            attrs: {
              "is-affiliate-referral": _vm.isAffiliateReferral,
              affiliate: _vm.affiliate,
              "has-active-old-plan": _vm.hasActiveOldPlan,
              "has-not-offered-plan": _vm.hasNotOfferedPlan,
              "current-sub-name": _vm.currentSubName,
            },
          }),
          _vm._v(" "),
          _vm.saleActive && !_vm.isMaxUser && !_vm.hasPlusPlan
            ? [
                _c("promo-alert", {
                  attrs: {
                    "promo-code": _vm.promoCode,
                    discount: _vm.discountPercent,
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isUpgrading && !_vm.saleActive
            ? _c(
                "section",
                { staticClass: "size-md tablet:size-sm margin-top-4xl" },
                [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row roomy" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "column-12 laptop:column-10 laptop:offset-2",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "message success size-reset-md margin-bottom-0",
                            },
                            [
                              _c("strong", [_vm._v("Hey Awesome Subscriber!")]),
                              _vm._v(
                                " Since you already have a subscription, the cost of any plan upgrade will be pro-rated.\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            {
              class: `padding-bottom-xl size-md tablet:size-sm margin-top-4xl`,
              staticStyle: {
                "--sale-theme-color": "var(--fa-teal)",
                "--sale-theme-color-dk": "var(--fa-dk-teal)",
                "--sale-link-color": "var(--fa-navy)",
              },
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _vm.plusPlansEnabled
                    ? _c(
                        "div",
                        { staticClass: "row roomy margin-bottom-3xl" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "column-12 laptop:column-10 laptop:offset-2",
                              staticStyle: {
                                display: "flex",
                                "place-content": "center",
                              },
                            },
                            [
                              _c("slide-toggle", {
                                on: { "toggle-plans": _vm.togglePlans },
                                model: {
                                  value: _vm.viewablePlans,
                                  callback: function ($$v) {
                                    _vm.viewablePlans = $$v
                                  },
                                  expression: "viewablePlans",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c("wa-icons-loading", { attrs: { transition: false } })
                    : _c(
                        "div",
                        { staticClass: "row roomy align-bottom" },
                        [
                          _c("plans-supplementary-info-section"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "plans-summary-cards column-12 laptop:column-10 tablet:display-flex",
                            },
                            _vm._l(_vm.plans, function (sku) {
                              return _c("plan-summary-card", {
                                key: sku,
                                attrs: {
                                  plan: _vm.planBySku(sku),
                                  "plan-color": _vm.planColor(sku),
                                  "plan-icon-style": _vm.planIconStyle(sku),
                                  "current-subscription":
                                    _vm.currentSubscription,
                                  "subscription-discounts":
                                    _vm.subscriptionDiscounts,
                                  "on-sale": _vm.onSale(sku),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "margin-bottom-6xl size-md tablet:size-sm" },
            [
              _c(
                "div",
                {
                  staticClass: "container",
                  staticStyle: { position: "relative" },
                },
                [
                  _vm.plusPlansEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "column-12 laptop:column-10 laptop:offset-2 margin-top-xl laptop:margin-top-0 tablet:display-flex align-between laptop:align-center laptop:padding-x-sm",
                        },
                        [
                          _c("h3", { staticClass: "laptop:display-none" }, [
                            _vm._v("Compare Plans"),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.compareAllPlans,
                                  expression: "compareAllPlans",
                                },
                              ],
                              staticClass: "with-icon",
                              attrs: { id: "compare-all", type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.compareAllPlans)
                                  ? _vm._i(_vm.compareAllPlans, null) > -1
                                  : _vm.compareAllPlans,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.compareAllPlans,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.compareAllPlans = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.compareAllPlans = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.compareAllPlans = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  display: "flex !important",
                                  gap: "var(--spacing-xs)",
                                },
                                attrs: { for: "compare-all" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "position-relative" },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "unchecked-icon",
                                      staticStyle: { color: "var(--white)" },
                                      attrs: {
                                        icon: _vm.$v6.solid.faSquare,
                                        "fixed-width": "",
                                        size: "lg",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("font-awesome-icon", {
                                      staticClass: "hover-icon",
                                      staticStyle: { color: "var(--white)" },
                                      attrs: {
                                        icon: _vm.$v6.solid.faSquare,
                                        "fixed-width": "",
                                        size: "lg",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("font-awesome-icon", {
                                      staticClass: "checked-icon",
                                      attrs: {
                                        icon: _vm.$v6.solid.faSquareCheck,
                                        "fixed-width": "",
                                        size: "lg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "label display-block margin-top-0 margin-bottom-3xs",
                                  },
                                  [_vm._v("Compare All Plans")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "wrap-compare-tables",
                        { "comparing-all": _vm.compareAllPlans },
                      ],
                    },
                    _vm._l(_vm.tableRows, function (tableRow, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "plan-compare-table padding-y-xs",
                          staticStyle: {
                            "background-color": "var(--fa-lt-gravy)",
                          },
                        },
                        _vm._l(tableRow, function (row, tIndex) {
                          return _c(
                            "plan-compare-table",
                            _vm._b(
                              {
                                key: tIndex,
                                attrs: {
                                  "plans-by-sku": _vm.comparablePlans,
                                  "current-plans": _vm.currentPlans,
                                },
                              },
                              "plan-compare-table",
                              row,
                              false
                            )
                          )
                        }),
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("faqs-section", {
            attrs: {
              "is-affiliate-referral": _vm.isAffiliateReferral,
              affiliate: _vm.affiliate,
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }